package org.dronda.app.web.ui.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.ColumnScope
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.width
import org.dronda.app.web.ui.util.rememberWindowSize
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

/**
 * The centred page column used by the event screens: 70% wide on large windows, 90% on small ones.
 */
@Composable
fun PageColumn(content: @Composable ColumnScope.() -> Unit) {
    val windowSize by rememberWindowSize()
    val mainWidth = remember(windowSize) { if (windowSize.width > 800) 70.percent else 90.percent }

    Row(
        modifier = Modifier.fillMaxWidth().padding(top = 50.px, bottom = 50.px),
        horizontalArrangement = Arrangement.Center,
    ) {
        Column(
            modifier = Modifier.width(mainWidth),
            verticalArrangement = Arrangement.spacedBy(1.cssRem),
            content = content,
        )
    }
}
